module.exports = __webpack_public_path__ + "img/magento-support-security@2x.4b082bb2.jpg";